import { createEvent } from 'effector';

import { FormDynamicFormState } from './FormDynamicFormState';

export const formDynamicFormEvent =
  createEvent<Partial<FormDynamicFormState>>('formDynamicFormEvent');
